import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import "./sahibindenFilters.css";

// Yön (kind) seçimi: Tümü / Alınan / Satılan.
// selectedFilter.kind backend'e ['buyer'] | ['seller'] olarak gider.
const OPTIONS = [
  { value: null, label: "Tümü", color: "#2a64c4" },
  { value: "buyer", label: "Alınan", color: "#F08A3E" },
  { value: "seller", label: "Satılan", color: "#1EC28B" },
];

const KindFilter = (props) => {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const active = selectedFilter.kind ? selectedFilter.kind[0] : null;

  const select = (value) => {
    if (!value) props.removeFilter({ parent: "kind" });
    else props.addSingleFilter({ parent: "kind", value });
  };

  return (
    <div className="kind-filter mt-3 mr-1">
      {OPTIONS.map((opt) => {
        const isActive = active === opt.value;
        return (
          <button
            key={opt.label}
            type="button"
            onClick={() => select(opt.value)}
            className="kind-filter-option"
            style={{
              background: isActive ? opt.color : "#fff",
              color: isActive ? "#fff" : opt.color,
              borderColor: opt.color,
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default connect(null, {
  ...categoryRedux.actions,
  ...advertRedux.actions,
})(KindFilter);
